
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Prompt } from "@/lib/types";
import { toDatabaseValue } from "@/utils/supabase/type-guards";

export const usePromptEdit = (
  prompt: Prompt | null,
  user: any,
  onUpdate?: (id: string, updatedPrompt: Partial<Prompt>) => void
) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const handleEditSave = async (updatedPrompt: Partial<Prompt>) => {
    if (!user || !prompt) return;
    
    try {
      const updateData: any = {
        title: updatedPrompt.title,
        content: updatedPrompt.content,
        category: updatedPrompt.category
      };

      // Only update category_edit_count if it's provided
      if (updatedPrompt.categoryEditCount !== undefined) {
        updateData.category_edit_count = updatedPrompt.categoryEditCount;
      }

      const { error } = await supabase
        .from('prompts')
        .update(toDatabaseValue(updateData))
        .eq('id', toDatabaseValue(prompt.id))
        .eq('user_id', toDatabaseValue(user.id));
      
      if (error) throw error;
      
      if (onUpdate) {
        onUpdate(prompt.id, {
          ...updatedPrompt,
          editedAt: new Date().toISOString(),
        });
      }
      
      toast.success("Prompt updated");
      setIsEditDialogOpen(false);
    } catch (error: any) {
      console.error('Error updating prompt:', error);
      toast.error(error.message || "Failed to update prompt");
    }
  };

  return {
    isEditDialogOpen,
    setIsEditDialogOpen,
    handleEditSave
  };
};
